module.exports = __webpack_public_path__ + "static/media/prueba.fa18723b.jpg";